import { Graphics } from "pixi.js";
import { PixiComponent } from "@inlet/react-pixi";

export type RectangleProps = {
  color: number;
  height: number;
  width: number;
  x: number;
  y: number;
};

const Rectangle = PixiComponent<RectangleProps, Graphics>("Rectangle", {
  create() {
    return new Graphics();
  },
  applyProps(instance, _, newProps) {
    const { color, x, y, width, height } = newProps;
    instance.clear();
    instance.lineStyle(1, color, 0.8);
    instance.drawRect(x, y, width, height);
    instance.endFill();
  },
});

export default Rectangle;
